import React, { useRef, useState } from 'react';
import { Button, Flexbox, Icon, useOnClickOutside } from '@hiiretail/synergy-ui';
import styled from 'styled-components';
import { authContextFromToken } from '@hiiretail/auth-context';
import firebase from 'firebase';

type UserMenuProps = {
  title: string;
  firebaseApp: firebase.app.App | null;
};

export type UserMenuComponent = React.FC<UserMenuProps>;

const UserMenuWrapper = styled(Flexbox)`
  position: relative;
`;

const UserMenuContent = styled(Flexbox)`
  position: absolute;
  background-color: #f9fafb;
  color: black;
  padding-bottom: ${(props) => props.theme.spacing(2)}px;
  box-shadow: 0 3px 5px rgba(9, 30, 66, 0.2), 0 0 1px rgba(9, 30, 66, 0.31);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  width: 100%;
  height: max-content;
  z-index: 1000;
  top: 95%;
  min-width: 120px;
  right: 0;
`;

const MenuTrigger = styled(Button)`
  z-index: 1001;

  span {
    display: flex;
  }
`;

export const UserMenu: UserMenuComponent = ({ title, children, firebaseApp }) => {
  const [isOpen, setIsOpen] = useState(false);

  const containerRef = useRef(null);
  useOnClickOutside(containerRef, () => setIsOpen(false));

  const handleProfileBtnClick = () => {
    setIsOpen(false);
    globalThis.location.href = `${globalThis.location.origin}/iam/profile`;
  };

  // TODO integrate AuthContext and use lib method instead of copy-paste
  const handleLogoutBtnClick = async () => {
    setIsOpen(false);
    const redirectUrl = `${globalThis.location.origin}/login?redirect=false`;
    console.log('idp logout started');
    // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
    const tokenResult = await firebaseApp?.auth().currentUser!.getIdTokenResult();
    const authContext = authContextFromToken(tokenResult?.token, {
      allowTokenTypes: ['iam-jwt-token'],
    });

    const providerId = authContext.data.fb.sign_in_provider;
    const logoutUrl = `https://iam-api.retailsvc.com/api/v1/tenants/${localStorage.getItem(
      'tenantId',
    )}/user-profile/logout?idProviderConnectionId=${providerId}&fallbackRedirectUrl=${redirectUrl}`;
    console.log('opening logout url');
    globalThis.open(logoutUrl);
    console.log('calling firebase sign out');
    await firebaseApp?.auth().signOut();
  };

  return (
    <UserMenuWrapper container ref={containerRef}>
      <MenuTrigger variant="secondary" onClick={() => setIsOpen((prevState) => !prevState)}>
        {title?.length && title ? title : <Icon.Person size="sm" />}
      </MenuTrigger>
      {isOpen && (
        <UserMenuContent container direction="column">
          {children}
          <Flexbox item container>
            <Button fullWidth variant="secondary" onClick={handleProfileBtnClick}>
              Profile
            </Button>
          </Flexbox>
          <Flexbox item container>
            <Button fullWidth variant="secondary" onClick={handleLogoutBtnClick}>
              Logout
            </Button>
          </Flexbox>
        </UserMenuContent>
      )}
    </UserMenuWrapper>
  );
};
